
import state from './reportsState.js'
import * as mutations from './reportsMutations.js'
import * as actions from './reportsActions.js'
import * as getters from './reportsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}